// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { FeatureFlagsGet } from '../../../../types/server/modules/featureFlags/get';

export type * from '../../../../types/server/modules/featureFlags/get';

export const createGet = ( requests: Requests ): FeatureFlagsGet => ({
  public_flags: ( headers ) => {
      return requests.get( `/public-flags`, undefined, headers );
    }
});
